import angular from "angular";
import uiRouter from "angular-ui-router";
import routing from "./adDefaults.routes";
import adModal from "./adDefault.modal.html";
import fu from "../../components/modal/FileUpload.html";

export class AdDefaultsComponent {
  $http;
  socket;
  adDefaults = [];

  /*@ngInject*/
  constructor(
    $http,
    $scope,
    socket,
    $uibModal,
    $cookies,
    $cookieStore,
    $location
  ) {
    this.$http = $http;
    this.socket = socket;
    this.$uibModal = $uibModal;
    this.$cookies = $cookies;
    this.$cookieStore = $cookieStore;
    this.$location = $location;

    this.languageTypes = [
      { value: "pt", name: "葡语" },
      { value: "en", name: "英语" },
      { value: "es", name: "西语" },
    ];
  }

  $onInit() {
    this.$http.get("/api/ad_defaults?backendType=image").then((response) => {
      if (response.data.data) {
        this.adDefaults = response.data.data;
        this.totalCount = response.data.data.length;
      }
    });
  }

  createOne() {
    const that = this;
    this.$uibModal.open({
      template: adModal,
      size: "lg",
      /*@ngInject*/
      controller($scope, $http, $uibModalInstance, FileUploader) {
        $scope.vm = {};
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.save = function (myForm) {
          if (myForm.$valid === false) {
            return false;
          } else {
            $http.post("/api/ad_defaults", $scope.vm).then(
              (response) => {
                that.$onInit();
                $uibModalInstance.close();
              },
              (error) => {
                console.log(error);
              }
            );
          }
        };

        $scope.uploadAndGetUrl = function () {
          that.$uibModal.open({
            template: fu,
            size: "lg",
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
              $scope.vm = {};
              $scope.isUpping = false;
              $scope.isUppingError = false;
              const uploader = ($scope.imageUploader = new FileUploader({
                url: "/api/share_imgs/9528/",
                method: "POST",
                autoUpload: true,
              }));
              uploader.onSuccessItem = function (
                fileItem,
                response,
                status,
                headers
              ) {
                if (status === 200) {
                  $scope.isUpping = false;
                  $scope.vm.url = response.data.small_img;
                }
              };
              uploader.filters.push({
                name: "Filter",
                fn(item, options) {
                  $scope.isUpping = true;
                  $scope.isUppingError = false;
                  return true;
                },
              });
              $scope.cancel = function () {
                $uibModalInstance.close();
              };
            },
          });
        };
      },
    });
  }

  delete(ad) {
    this.$http.delete(`/api/ad_defaults/${ad._id}`).then((response) => {
      this.$onInit();
    });
  }

  edit(ad) {
    const that = this;
    this.$uibModal.open({
      template: adModal,
      size: "lg",
      /*@ngInject*/
      controller($scope, $http, $uibModalInstance, FileUploader) {
        $scope.vm = ad;
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        $scope.save = function (myForm) {
          if (myForm.$valid === false) {
            return false;
          } else {
            $http.post("/api/ad_defaults", $scope.vm).then(
              (response) => {
                that.$onInit();
                $uibModalInstance.close();
              },
              (error) => {
                console.log(error);
              }
            );
          }
        };
        $scope.uploadAndGetUrl = function () {
          that.$uibModal.open({
            template: fu,
            size: "lg",
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
              $scope.vm = {};
              $scope.isUpping = false;
              $scope.isUppingError = false;
              const uploader = ($scope.imageUploader = new FileUploader({
                url: "/api/share_imgs/9528/",
                method: "POST",
                autoUpload: true,
              }));
              uploader.onSuccessItem = function (
                fileItem,
                response,
                status,
                headers
              ) {
                if (status === 200) {
                  $scope.isUpping = false;
                  $scope.vm.url = response.data.small_img;
                }
              };
              uploader.filters.push({
                name: "Filter",
                fn(item, options) {
                  $scope.isUpping = true;
                  $scope.isUppingError = false;
                  return true;
                },
              });
              $scope.cancel = function () {
                $uibModalInstance.close();
              };
            },
          });
        };
      },
    });
  }
}

export default angular
  .module("tttApp.adDefaults", [uiRouter])
  .config(routing)
  .component("adDefaults", {
    template: require("./adDefaults.html"),
    controller: AdDefaultsComponent,
  }).name;



// WEBPACK FOOTER //
// ./client/app/adDefaults/adDefaults.component.js